import { render, staticRenderFns } from "./configurationModel.vue?vue&type=template&id=99d8c1ee"
import script from "./configurationModel.vue?vue&type=script&lang=js"
export * from "./configurationModel.vue?vue&type=script&lang=js"
import style0 from "./configurationModel.vue?vue&type=style&index=0&id=99d8c1ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports